import { TaskV2ArchivedBannerComponent } from '../components/task-v2-archived-banner/task-v2-archived-banner.component';
import { FiTaskV2ViewAssigneesDialogComponent } from './task-v2-assignee/fi-task-v2-view-assignees-dialog/fi-task-v2-view-assignees-dialog.component';
import { FiTaskV2AssigneesListComponent } from './task-v2-assignee/fi-task-v2-assignees-list/fi-task-v2-assignees-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTaskV2DetailsComponent } from './fi-task-v2-details.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { TaskV2StaffAssigneeComponent } from './task-v2-assignee/task-v2-staff-assignee/task-v2-staff-assignee.component';
import { TaskV2RoleUnitAssigneeComponent } from './task-v2-assignee/task-v2-role-unit-assignee/task-v2-role-unit-assignee.component';
import { TaskV2CreatorEditorComponent } from './task-v2-assignee/task-v2-creator-editor/task-v2-creator-editor.component';
import { TaskV2ShowMoreComponent } from './task-v2-assignee/task-v2-show-more/task-v2-show-more.component';
import { FiTaskV2AssigneeHelperService } from './task-v2-assignee/fi-task-v2-assignee-helper.service';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FiEditorPageHeaderModule } from '@fi-shared/fi-editor-page-header/fi-editor-page-header.module';
import { FiTaskV2SharedComponentsModule } from '../components/fi-task-v2-shared-components.module';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiTaskV2DescriptionComponent } from './task-v2-description/task-v2-description.component';
import { TaskV2StatusComponent } from './task-v2-status/task-v2-status.component';
import { TaskV2LogComponent } from './task-v2-log/task-v2-log.component';
import { TaskV2AssigneeComponent } from './task-v2-assignee/task-v2-assignee.component';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { TaskV2LogItemComponent } from './task-v2-log/task-v2-log-item/task-v2-log-item.component';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { TaskV2AddAssigneesDialogComponent } from './task-v2-assignee/fi-task-v2-add-assignees-dialog/fi-task-v2-add-assignees-dialog.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiDirectivesModule } from '@fi-app/shared/fi-directives/fi-directives.module';
import { FiProgressBadgeModule } from '@fi-app/shared/fi-progress-badge/fi-progress-badge.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiRollupContentModule,
        MatCardModule,
        MatIconModule,
        FiEditorPageHeaderModule,
        FiTaskV2SharedComponentsModule,
        FiTwoColumnsContainerModule,
        FiAttachmentsModule,
        FiBindHtmlCompileModule,
        MatButtonModule,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        FiFormatDateModule,
        FiProfileIconModule,
        FiLoadingModule,
        SelectSearchModule,
        InfoIconModule,
        FiDirectivesModule,
        FiProgressBadgeModule,
    ],
    declarations: [
        FiTaskV2DetailsComponent,
        FiTaskV2DescriptionComponent,
        TaskV2StatusComponent,
        TaskV2LogComponent,
        TaskV2AssigneeComponent,
        TaskV2LogItemComponent,
        TaskV2AddAssigneesDialogComponent,
        FiTaskV2AssigneesListComponent,
        FiTaskV2ViewAssigneesDialogComponent,
        TaskV2StaffAssigneeComponent,
        TaskV2RoleUnitAssigneeComponent,
        TaskV2CreatorEditorComponent,
        TaskV2ShowMoreComponent,
    ],
    providers: [FiTaskV2AssigneeHelperService],
})
export class FiTaskV2DetailsModule {}
